export default "__VITE_ASSET__B8j7ekId__"